<template>
  <div class="wh-wrap">

    <!-- Tabs -->
    <div class="wh-tabs">
      <button class="wh-tab" :class="{ 'wh-tab--active': tab === 'config' }" @click="tab = 'config'">
        <feather-icon icon="SettingsIcon" size="14" />
        Configuracao
      </button>
      <button class="wh-tab" :class="{ 'wh-tab--active': tab === 'events' }" @click="tab = 'events'; loadEvents()">
        <feather-icon icon="ActivityIcon" size="14" />
        Eventos Recebidos
        <span v-if="totalEvents > 0" class="wh-tab__badge">{{ totalEvents }}</span>
      </button>
    </div>

    <!-- TAB: Config -->
    <div v-show="tab === 'config'">

    <div class="wh-header">
      <div class="wh-header-left">
        <div class="wh-header-icon">
          <feather-icon icon="LinkIcon" size="16" />
        </div>
        <div>
          <div class="wh-header-title">Webhooks</div>
          <div class="wh-header-sub">URLs para integrar com plataformas de pagamento e automacoes externas</div>
        </div>
      </div>
    </div>

    <!-- Webhook: Novo Cliente (Kiwify) -->
    <div class="wh-section">
      <div class="wh-section-title">Novo Cliente (Kiwify)</div>
      <p class="wh-section-desc">Configure esta URL no Kiwify para criar automaticamente o usuario quando uma compra for aprovada. O sistema cria a conta, envia email de boas-vindas e libera o acesso.</p>

      <div class="wh-url-card">
        <div class="wh-url-card__label">URL do Webhook</div>
        <div class="wh-url-card__row">
          <div class="wh-url-card__method">POST</div>
          <input class="wh-url-card__input" :value="webhookKiwify" readonly ref="urlKiwify" />
          <button class="wh-url-card__copy" @click="copiar('urlKiwify')">
            <feather-icon :icon="copied === 'urlKiwify' ? 'CheckIcon' : 'CopyIcon'" size="14" />
            {{ copied === 'urlKiwify' ? 'Copiado!' : 'Copiar' }}
          </button>
        </div>
        <div class="wh-url-card__info">
          <div class="wh-url-card__info-item">
            <feather-icon icon="CheckCircleIcon" size="12" />
            Cria usuario automaticamente
          </div>
          <div class="wh-url-card__info-item">
            <feather-icon icon="MailIcon" size="12" />
            Envia email de boas-vindas
          </div>
          <div class="wh-url-card__info-item">
            <feather-icon icon="KeyIcon" size="12" />
            Link para definir senha
          </div>
          <div class="wh-url-card__info-item">
            <feather-icon icon="CreditCardIcon" size="12" />
            Registra pagamento
          </div>
        </div>
      </div>

      <div class="wh-payload">
        <div class="wh-payload__title">Payload esperado (Kiwify envia automaticamente)</div>
        <pre class="wh-payload__code">{
  "Customer": {
    "email": "cliente@email.com",
    "full_name": "Nome do Cliente",
    "mobile": "11999998888"
  },
  "order_status": "paid",
  "payment_method": "credit_card"
}</pre>
      </div>
    </div>

    <!-- Webhook: Compra Aprovada (generico) -->
    <div class="wh-section">
      <div class="wh-section-title">Compra Aprovada (Generico)</div>
      <p class="wh-section-desc">Webhook alternativo para outras plataformas de pagamento. Cria ou atualiza o usuario.</p>

      <div class="wh-url-card">
        <div class="wh-url-card__label">URL do Webhook</div>
        <div class="wh-url-card__row">
          <div class="wh-url-card__method">POST</div>
          <input class="wh-url-card__input" :value="webhookGenerico" readonly ref="urlGenerico" />
          <button class="wh-url-card__copy" @click="copiar('urlGenerico')">
            <feather-icon :icon="copied === 'urlGenerico' ? 'CheckIcon' : 'CopyIcon'" size="14" />
            {{ copied === 'urlGenerico' ? 'Copiado!' : 'Copiar' }}
          </button>
        </div>
      </div>

      <div class="wh-payload">
        <div class="wh-payload__title">Payload esperado</div>
        <pre class="wh-payload__code">{
  "user_email": "cliente@email.com",
  "user_name": "Nome do Cliente",
  "user_phone": "11999998888",
  "user_password": "opcional",
  "fiId": "id-externo-opcional"
}</pre>
      </div>
    </div>

    <!-- Webhook: Primeiro Acesso -->
    <div class="wh-section">
      <div class="wh-section-title">Primeiro Acesso (Validacao)</div>
      <p class="wh-section-desc">Endpoints usados pela tela de primeiro acesso do cliente. Nao precisa configurar - sao usados internamente.</p>

      <div class="wh-url-card wh-url-card--muted">
        <div class="wh-url-card__row">
          <div class="wh-url-card__method wh-url-card__method--blue">POST</div>
          <input class="wh-url-card__input" :value="baseUrl + '/api/dkbackend/primeiro-acesso/validar'" readonly />
        </div>
        <div class="wh-url-card__row" style="margin-top:8px">
          <div class="wh-url-card__method wh-url-card__method--blue">POST</div>
          <input class="wh-url-card__input" :value="baseUrl + '/api/dkbackend/primeiro-acesso/definir-senha'" readonly />
        </div>
      </div>
    </div>

    </div><!-- /tab config -->

    <!-- TAB: Eventos -->
    <div v-show="tab === 'events'">

      <!-- Filtro -->
      <div class="wh-events-filter">
        <button class="wh-filter-btn" :class="{ 'wh-filter-btn--active': eventFilter === '' }" @click="eventFilter = ''; loadEvents()">Todos</button>
        <button class="wh-filter-btn" :class="{ 'wh-filter-btn--active': eventFilter === 'prod' }" @click="eventFilter = 'prod'; loadEvents()">Producao</button>
        <button class="wh-filter-btn" :class="{ 'wh-filter-btn--active': eventFilter === 'test' }" @click="eventFilter = 'test'; loadEvents()">Teste</button>
        <div style="flex:1"></div>
        <button class="wh-clear-btn" @click="clearLogs" v-if="events.length">
          <feather-icon icon="Trash2Icon" size="13" /> Limpar logs
        </button>
      </div>

      <!-- Loading -->
      <div v-if="eventsLoading" class="wh-events-loading">Carregando eventos...</div>

      <!-- Empty -->
      <div v-else-if="!events.length" class="wh-events-empty">
        <feather-icon icon="InboxIcon" size="32" />
        <p>Nenhum evento recebido ainda</p>
      </div>

      <!-- Lista -->
      <div v-else class="wh-events-list">
        <div v-for="ev in events" :key="ev.id" class="wh-event" :class="{ 'wh-event--test': ev.is_test }">
          <div class="wh-event__top">
            <div class="wh-event__method">POST</div>
            <div class="wh-event__endpoint">/{{ ev.endpoint }}</div>
            <div class="wh-event__status" :class="ev.status_code === 200 ? 'wh-event__status--ok' : 'wh-event__status--err'">{{ ev.status_code }}</div>
            <div v-if="ev.is_test" class="wh-event__test-badge">TESTE</div>
            <div class="wh-event__date">{{ formatDate(ev.created_at) }}</div>
          </div>
          <div class="wh-event__response">{{ ev.response }}</div>
          <div v-if="ev.showPayload" class="wh-event__payload">
            <pre>{{ formatPayload(ev.payload) }}</pre>
          </div>
          <button class="wh-event__toggle" @click="ev.showPayload = !ev.showPayload">
            {{ ev.showPayload ? 'Esconder payload' : 'Ver payload' }}
          </button>
        </div>
      </div>

    </div><!-- /tab events -->

  </div>
</template>

<script>
export default {
  name: 'WebhooksAdmin',
  data() {
    return {
      tab: 'config',
      copied: '',
      events: [],
      eventsLoading: false,
      totalEvents: 0,
      eventFilter: '',
    }
  },
  computed: {
    baseUrl() { return 'https://vslbooster.com' },
    webhookKiwify() { return this.baseUrl + '/api/dkbackend/webhooks/kiwifCadClient' },
    webhookGenerico() { return this.baseUrl + '/api/dkbackend/webhooks/compraAprovada' },
  },
  methods: {
    api() { return process.env.VUE_APP_HOST_API_BACKEND || '/api/dkbackend' },
    copiar(ref) {
      const input = this.$refs[ref]
      if (input) {
        input.select()
        navigator.clipboard.writeText(input.value).catch(() => document.execCommand('copy'))
      }
      this.copied = ref
      setTimeout(() => { this.copied = '' }, 3000)
    },
    async loadEvents() {
      this.eventsLoading = true
      try {
        const resp = await fetch(`${this.api()}/webhook-logs?limit=100&filter=${this.eventFilter}`)
        const data = await resp.json()
        this.events = (data.events || []).map(e => ({ ...e, showPayload: false }))
        this.totalEvents = data.total || 0
      } catch (e) { console.error(e) }
      finally { this.eventsLoading = false }
    },
    async clearLogs() {
      if (!confirm('Limpar todos os logs de webhook?')) return
      try {
        await fetch(`${this.api()}/webhook-logs`, { method: 'DELETE' })
        this.events = []
        this.totalEvents = 0
        this.$message({ type: 'success', message: 'Logs limpos' })
      } catch (e) { console.error(e) }
    },
    formatDate(dt) {
      if (!dt) return ''
      const d = new Date(dt)
      return d.toLocaleDateString('pt-BR') + ' ' + d.toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit', second: '2-digit' })
    },
    formatPayload(p) {
      try { return JSON.stringify(JSON.parse(p), null, 2) } catch { return p }
    },
  },
}
</script>

<style scoped>
.wh-wrap { padding: 28px 32px; max-width: 800px; }

/* Tabs */
.wh-tabs { display: flex; gap: 4px; margin-bottom: 24px; background: rgba(255,255,255,0.03); border-radius: 10px; padding: 4px; }
.wh-tab { display: flex; align-items: center; gap: 6px; padding: 10px 20px; border-radius: 8px; border: none; background: transparent; color: var(--dk-text-muted, #8a94a6); font-size: 13px; font-weight: 600; cursor: pointer; font-family: inherit; transition: all 0.15s; }
.wh-tab:hover { color: var(--dk-text-primary, #e2e8f0); }
.wh-tab--active { background: var(--dk-bg-card, #1a2840); color: #E86A10; box-shadow: 0 1px 4px rgba(0,0,0,0.1); }
.wh-tab__badge { background: #E86A10; color: #fff; font-size: 10px; font-weight: 800; padding: 1px 7px; border-radius: 10px; }

/* Events filter */
.wh-events-filter { display: flex; gap: 6px; margin-bottom: 16px; align-items: center; }
.wh-filter-btn { padding: 6px 14px; border-radius: 6px; border: 1px solid rgba(255,255,255,0.08); background: transparent; color: var(--dk-text-muted, #8a94a6); font-size: 12px; font-weight: 600; cursor: pointer; font-family: inherit; transition: all 0.15s; }
.wh-filter-btn:hover { border-color: rgba(255,255,255,0.15); }
.wh-filter-btn--active { background: rgba(232,106,16,0.1); border-color: #E86A10; color: #E86A10; }
.wh-clear-btn { display: flex; align-items: center; gap: 5px; padding: 6px 12px; border-radius: 6px; border: 1px solid rgba(239,68,68,0.2); background: rgba(239,68,68,0.06); color: #EF4444; font-size: 11px; font-weight: 600; cursor: pointer; font-family: inherit; }

/* Events list */
.wh-events-loading, .wh-events-empty { text-align: center; padding: 40px; color: var(--dk-text-muted); font-size: 13px; }
.wh-events-empty svg { opacity: 0.3; margin-bottom: 8px; }
.wh-events-list { display: flex; flex-direction: column; gap: 8px; }
.wh-event { background: rgba(255,255,255,0.02); border: 1px solid rgba(255,255,255,0.06); border-radius: 10px; padding: 14px 16px; }
.wh-event--test { border-left: 3px solid #F5B935; }
.wh-event__top { display: flex; align-items: center; gap: 8px; flex-wrap: wrap; }
.wh-event__method { padding: 3px 8px; border-radius: 4px; background: rgba(232,106,16,0.12); color: #E86A10; font-size: 10px; font-weight: 800; }
.wh-event__endpoint { font-size: 12px; font-weight: 600; color: var(--dk-text-primary, #e2e8f0); font-family: monospace; }
.wh-event__status { padding: 2px 8px; border-radius: 4px; font-size: 10px; font-weight: 800; }
.wh-event__status--ok { background: rgba(16,185,129,0.12); color: #10B981; }
.wh-event__status--err { background: rgba(239,68,68,0.12); color: #EF4444; }
.wh-event__test-badge { padding: 2px 8px; border-radius: 4px; background: rgba(245,185,53,0.15); color: #F5B935; font-size: 10px; font-weight: 800; }
.wh-event__date { font-size: 11px; color: var(--dk-text-muted, #64748b); margin-left: auto; }
.wh-event__response { font-size: 12px; color: var(--dk-text-muted, #8a94a6); margin-top: 6px; }
.wh-event__payload { margin-top: 8px; }
.wh-event__payload pre { background: #0D1B2E; border-radius: 6px; padding: 10px 12px; font-size: 11px; color: #F5B935; overflow-x: auto; margin: 0; line-height: 1.5; }
.wh-event__toggle { background: none; border: none; color: var(--dk-text-muted, #64748b); font-size: 11px; cursor: pointer; padding: 4px 0; margin-top: 4px; font-family: inherit; }
.wh-event__toggle:hover { color: #E86A10; }

.wh-header { display: flex; align-items: center; gap: 12px; margin-bottom: 28px; }
.wh-header-left { display: flex; align-items: center; gap: 12px; }
.wh-header-icon { width: 40px; height: 40px; border-radius: 10px; background: rgba(232,106,16,0.1); display: flex; align-items: center; justify-content: center; color: #E86A10; flex-shrink: 0; }
.wh-header-title { font-size: 15px; font-weight: 700; color: var(--dk-text-primary, #e2e8f0); }
.wh-header-sub { font-size: 12px; color: var(--dk-text-muted, #8a94a6); margin-top: 2px; }

.wh-section { margin-bottom: 32px; }
.wh-section-title { font-size: 14px; font-weight: 700; color: var(--dk-text-primary, #e2e8f0); margin-bottom: 6px; }
.wh-section-desc { font-size: 12px; color: var(--dk-text-muted, #8a94a6); line-height: 1.5; margin-bottom: 14px; }

.wh-url-card { background: rgba(255,255,255,0.03); border: 1.5px solid rgba(255,255,255,0.08); border-radius: 10px; padding: 16px; }
.wh-url-card--muted { opacity: 0.7; }
.wh-url-card__label { font-size: 11px; font-weight: 700; color: var(--dk-text-muted, #8a94a6); text-transform: uppercase; letter-spacing: 0.5px; margin-bottom: 8px; }
.wh-url-card__row { display: flex; gap: 8px; align-items: center; }
.wh-url-card__method { padding: 6px 12px; border-radius: 6px; background: rgba(232,106,16,0.12); color: #E86A10; font-size: 11px; font-weight: 800; flex-shrink: 0; }
.wh-url-card__method--blue { background: rgba(59,130,246,0.12); color: #3B82F6; }
.wh-url-card__input { flex: 1; padding: 8px 12px; background: rgba(255,255,255,0.04); border: 1px solid rgba(255,255,255,0.08); border-radius: 6px; color: var(--dk-text-primary, #e2e8f0); font-size: 12px; font-family: 'Fira Code', monospace; outline: none; }
.wh-url-card__copy { display: flex; align-items: center; gap: 6px; padding: 8px 16px; border-radius: 8px; border: none; background: #E86A10; color: #fff; font-size: 12px; font-weight: 700; cursor: pointer; flex-shrink: 0; transition: all 0.2s; font-family: inherit; }
.wh-url-card__copy:hover { background: #d45e0c; }
.wh-url-card__info { display: flex; flex-wrap: wrap; gap: 12px; margin-top: 12px; }
.wh-url-card__info-item { display: flex; align-items: center; gap: 5px; font-size: 11px; color: #10B981; font-weight: 500; }

.wh-payload { margin-top: 14px; }
.wh-payload__title { font-size: 11px; font-weight: 700; color: var(--dk-text-muted, #64748b); text-transform: uppercase; letter-spacing: 0.5px; margin-bottom: 8px; }
.wh-payload__code { background: #0D1B2E; border: 1px solid rgba(255,255,255,0.06); border-radius: 8px; padding: 14px 16px; font-family: 'Fira Code', monospace; font-size: 12px; color: #F5B935; line-height: 1.6; overflow-x: auto; margin: 0; }
</style>
